// Stable first-party visitor id, shared by the page_views beacon
// (utils/pageview.js) and the events tracker (utils/track.js). Both MUST use
// the same id so a visitor's page views and tracked events join on visitor_id
// — that join is what powers page-view → signup → paid attribution on
// /admin/outreach. Random localStorage UUID; not PII, no IP. Never throws.
const KEY = 'visitor_id';

export function getVisitorId() {
  try {
    let v = localStorage.getItem(KEY);
    if (!v) {
      v = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(KEY, v);
    }
    return v;
  } catch {
    return null;
  }
}
